import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Dietas keto/TikTok fallan',
    desc: 'Hambre + tamales familiares = rebote +2kg. Ignoran hormonas posparto.'
  }, {
    title: 'Videos "abs 10min" empeoran',
    desc: 'Crunches abren diástasis, dolor espalda con niños colgados.'
  }, {
    title: 'Fajas Amazon $45',
    desc: 'Comprimen sin fortalecer core profundo — panza igual debajo.'
  }, {
    title: 'Suplementos "milagro"',
    desc: '$80/mes sin ciencia posparto latina.'
  }, {
    title: 'Influencers genéricas',
    desc: 'No saben doble carga migrante USA + arroz diario.'
  }];
  return <Section className="bg-[#FFF8F0]" data-id="element-13">
      <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-12 text-center font-serif" data-id="element-14">
        ¿Por Qué Lo Que Probaste No Funcionó?
      </h2>

      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-15">
        {failures.map((item, index) => <div key={index} className="flex items-start bg-white p-6 rounded-lg shadow-sm" data-id="element-16">
            <XCircle className="w-6 h-6 text-red-400 mt-1 mr-4 flex-shrink-0" data-id="element-17" />
            <div data-id="element-18">
              <h3 className="font-bold text-[#2D2D2D] text-lg" data-id="element-19">{item.title}</h3>
              <p className="text-gray-600 mt-1" data-id="element-20">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}